export interface Petal {
  /** Direction of travel, in degrees. */
  angle: number;
  /** How far the petal travels, in pixels. */
  distance: number;
  /** Stagger before the petal starts moving, in milliseconds. */
  delay: number;
  /** Gold flecks are small circles; the rest are blush petals. */
  gold: boolean;
}

/**
 * Geometry for one burst. `rand` is injectable so tests get exact values.
 */
export function createPetals(count: number, rand: () => number = Math.random): Petal[] {
  return Array.from({ length: count }, (_, i) => ({
    angle: (360 / count) * i + rand() * 24 - 12,
    distance: 90 + rand() * 90,
    delay: rand() * 120,
    gold: i % 3 === 0,
  }));
}
